// const URL = "http://localhost:4000";

// export const URL = "http://167.99.199.80:4000";

// export const URL = "https://us-central1-sms-web101.cloudfunctions.net/api";
export const URL = "http://localhost:5000/sms-web101/us-central1/api";

export default URL;